import { APP_ROUTES } from '../../constants';
import { useNavigate } from 'react-router-dom';

// Components
import AcctSetupOption from './AcctSetupOption';
import { useSetAtom } from 'jotai';
import { resetCustomerAtom } from 'atoms/useSelectedCustomerAtom';
import { useIsRecalculatingHSA } from 'atoms/isRecalculatingHSA';
import { useOnboardingStepsAtom } from '../../atoms';

function AccountSetup() {
  const [, setIsRecalculatingHSA] = useIsRecalculatingHSA();
  const resetCustomer = useSetAtom(resetCustomerAtom);
  const navigate = useNavigate();
  const { incrementStep } = useOnboardingStepsAtom();

  const handleHSAOnboarding = () => {
    // Set isRecalculating to false to cleanup any stale state
    setIsRecalculatingHSA(false);
    // Clear the HSA form data local state (selectedCustomerAtom)
    resetCustomer();
    // Advance step to trigger navigation into the HSA onboarding flow
    incrementStep();
    // Navigate to the first HSA onboarding page (For First time HSA)
    navigate(APP_ROUTES.ONBOARD_ACCT_DETAILS);
  };

  // JSX
  return (
    <div className="fixed top-0 left-0 w-screen min-h-screen flex flex-col justify-center items-center gap-8">
      <div className="text-xl">
        <span>Select a Setup Option:</span>
      </div>
      <div className="flex gap-8 flex-wrap w-full justify-center">
        <AcctSetupOption
          icon="savings-jar.svg"
          content="Historical Savings Assessment"
          onClick={() => handleHSAOnboarding()}
          isTrial
        />
        <AcctSetupOption
          icon="bar-chart.png"
          content="Business Study for Competitive Intelligence"
          onClick={() =>
            navigate({
              pathname: APP_ROUTES.ON_BOARD,
              search: '?new_business=true',
            })
          }
          isTrial
        />
        <AcctSetupOption
          icon="user-add.svg"
          content="Client Onboarding"
          onClick={() => navigate(APP_ROUTES.ON_BOARD)}
        />
      </div>
    </div>
  );
}
export default AccountSetup;
